var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b8cffe5339"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 38 L 337.5 38 L 337.5 337 L 37.5 337 Z M 37.5 38 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b8cffe5339)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 299.792969 38.085938 L 75.121094 38.085938 C 54.476562 38.085938 37.5 55.035156 37.5 75.589844 L 37.5 299.230469 C 37.5 319.785156 54.476562 336.914062 75.121094 336.914062 L 186.914062 336.914062 L 186.914062 233.789062 L 150 233.789062 L 150 188.085938 L 186.914062 188.085938 L 186.914062 150.136719 C 186.914062 119.253906 212.605469 94.921875 243.628906 94.921875 L 281.835938 94.921875 L 281.835938 141.210938 L 262.347656 141.210938 C 252.015625 141.210938 243.75 139.847656 243.75 150.136719 L 243.75 188.085938 L 290.4375 188.085938 L 271.710938 233.789062 L 243.75 233.789062 L 243.75 336.914062 L 299.792969 336.914062 C 320.445312 336.914062 337.5 319.785156 337.5 299.230469 L 337.5 75.589844 C 337.5 55.035156 320.445312 38.085938 299.792969 38.085938 Z M 299.792969 38.085938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.9a04015363b8add5a9de0e2604e04a8b.svg";
export { ForwardRef as ReactComponent };